import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const StudentDetailQuery = graphql.persisted(
  "StudentDetailQuery",
  graphql(`
    query StudentDetailQuery($schoolId: ID!, $personId: ID!, $schoolYearId: ID!) {
      school(id: $schoolId) {
        id
        name
        slug
        checklistEnrollmentOn
        gradeLevelsSetting {
          items {
            description
            order
          }
        }
        person(id: $personId) {
          id
          firstName
          lastName
          fullName
          email
          phone
          gender
          dateOfBirth
          studentProfile {
            id
            dateOfBirth
            medicalInfo {
              medicalCondition
              otcMedicationPermission
              otcMedicationsApproved {
                acetaminophen
                ibuprofen
                coughDrops
                other
              }
              specialNeeds
              insuranceInfo {
                carrier
                groupNumber
                policyNumber
                policyHolderName
              }
            }
            adminMetadata {
              adminNotes
              academicProbation
              behavioralProbation
              pauseAutoReenroll
            }
          }
          studentEnrollmentForYear(schoolYearId: $schoolYearId) {
            id
            state
            enrollmentKind
            gradeLevel
            needsReview
            familyEnrollment {
              id
              state
              access
              accessSource
              enrollmentKind
              inviteStatus
              family {
                id
                name
                slug
              }
            }
          }
        }
      }
    }
  `)
);

export { StudentDetailQuery };

export function useStudentDetailQuery(schoolId: string | undefined, personId: string | undefined, schoolYearId: string | undefined) {
  return useQuery(StudentDetailQuery, {
    variables: {
      schoolId: schoolId!,
      personId: personId!,
      schoolYearId: schoolYearId || '',
    },
    skip: !schoolId || !personId,
  });
}
